import type { i18n as I18n } from "i18next";

export const addResources = (
  i18n: I18n,
  namespace: string,
  resources: Record<string, object>,
) => {
  const resources_ = unwrapResources(resources);
  Object.keys(resources_).forEach((key) => {
    i18n.addResourceBundle(key, namespace, resources_[key]);
  });
};

const unwrapResources = (resources: any): Record<string, object> => {
  return Object.keys(resources).reduce(
    (acc, lang) => ({
      ...acc,
      [lang]: {
        ...(resources[lang]?.default
          ? resources[lang]?.default
          : resources[lang]),
      },
    }),
    {},
  );
};
